/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";
import {
  getAccessTierDecoder,
  getAccessTierEncoder,
  getSlashReasonDecoder,
  getSlashReasonEncoder,
  type AccessTier,
  type AccessTierArgs,
  type SlashReason,
  type SlashReasonArgs,
} from ".";

export type GhostSlashedEvent = {
  agent: Address;
  amount: bigint;
  reason: SlashReason;
  newTier: AccessTier;
};

export type GhostSlashedEventArgs = {
  agent: Address;
  amount: number | bigint;
  reason: SlashReasonArgs;
  newTier: AccessTierArgs;
};

export function getGhostSlashedEventEncoder(): FixedSizeEncoder<GhostSlashedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["amount", getU64Encoder()],
    ["reason", getSlashReasonEncoder()],
    ["newTier", getAccessTierEncoder()],
  ]);
}

export function getGhostSlashedEventDecoder(): FixedSizeDecoder<GhostSlashedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["amount", getU64Decoder()],
    ["reason", getSlashReasonDecoder()],
    ["newTier", getAccessTierDecoder()],
  ]);
}

export function getGhostSlashedEventCodec(): FixedSizeCodec<
  GhostSlashedEventArgs,
  GhostSlashedEvent
> {
  return combineCodec(
    getGhostSlashedEventEncoder(),
    getGhostSlashedEventDecoder(),
  );
}
